







































































































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import ActivitySelect from '@/components/activity-select/index.vue'
import PicModal from '@/components/upload/picModal.vue'
import GoodSelect from '@/components/goods-select/index.vue'
import Pic from '../components/pic.vue'
import Swiper from '../components/swiper.vue'
import GoodsApi from '@/api/goods/list'
import HomeSetApi from '@/api/shopMall/pcMallDecorate/homeSet/index'
import homeSet from '@/api/shopMall/pcMallDecorate/homeSet/index'

@Component({
  components: {
    ActivitySelect,
    PicModal,
    GoodSelect,
    Pic,
    Swiper,
  },
})
export default class FloorSetEdit extends Vue {
  editId: any = null

  formValidate = {
    name: '',
    displayOrder: '',
    isActive: false,
    backgroundType: 0,
    backgroundUrl: '',
    // 0多图组件/1商品列表/2营销活动
    componentType: 0,
    // 图片组件数据
    photosComponent: {
      displayType: 0,
      // 0一行一个/1一行两个/2一行三个/3一行四个/4两左两右/5一行五个/6一左四右
      displayMode: 0,
      photoItems: [],
    },
    // 商品组件数据
    productsComponent: {
      productItems: [],
    },
    // 活动组件
    activitiesComponent: {
      activityItems: [],
    },
  }
  ruleValidate: any = {
    name: [
      {
        required: true,
        message: '请输入楼层名称',
        trigger: 'blur',
      },
    ],
    displayOrder: [
      { required: true, message: '排序不能为空' },
      { type: 'number', message: '排序必须为数字值' },
    ],
  }

  ProductsConfig: any = {
    selectType: 1,
    list: [],
    products: [],
    maxNumber: 12,
  }
  showGoodsIndex = -1
  categoryList = []

  PicturesConfig: any = {
    styleType: 0,
    imgUrl: [
      {
        img: null,
        url: null,
      },
    ],
  }

  SwiperConfig: any = {
    interval: 3000,
    imgUrl: [
      {
        img: null,
        url: null,
      },
    ],
  }

  loading: boolean = false

  created() {
    console.log('createdcreatedcreatedcreated')
    if (this.$route.query['id']) {
      this.editId = this.$route.query['id']
      this.getData()
    }
  }

  getData() {
    HomeSetApi.getFloorDataById(this.editId).then((res) => {
      if (res.data) {
        console.log('sdfsdaffa', res)
        const tempBackgroundUrl = res.data.backgroundUrl
        res.data.backgroundUrl = tempBackgroundUrl ? tempBackgroundUrl : ''
        this.formValidate = res.data
        // 反赋值回去
        const { photosComponent, productsComponent, componentType } = res.data
        // 根据组件类型做对应的反赋值
        switch (componentType) {
          // 多图组件
          case 0:
            if (photosComponent.displayType === 0) {
              let tempPicturesConfig = {
                styleType: photosComponent.displayMode,
                imgUrl: photosComponent.photoItems.map((o) => {
                  return { img: o.photoUrl, url: o.linkUrl }
                }),
              }
              this.PicturesConfig = tempPicturesConfig
            } else {
              // 轮播
              let tempSwiperConfig = {
                interval: 3000,
                styleType: photosComponent.displayMode,
                imgUrl: photosComponent.photoItems.map((o) => {
                  return { img: o.photoUrl, url: o.linkUrl }
                }),
              }
              this.SwiperConfig = tempSwiperConfig
              console.log(tempSwiperConfig)
            }
            break
          case 1:
            this.$set(
              this.ProductsConfig,
              'list',
              photosComponent.photoItems.map((o) => {
                return { pictureUrl: o.photoUrl, id: o.linkUrl }
              })
            )
            this.$set(
              this.ProductsConfig,
              'products',
              productsComponent.productItems.map((o) => {
                return {
                  productId: o.productId,
                  code: o.code,
                  name: o.name,
                  marketPrice: o.marketPrice,
                  price: o.price,
                  pictureUrl: o.pictureUrl,
                }
              })
            )
            break
          default:
            break
        }
      }
    })
  }

  backgroundTypeChange(radio) {
    this.formValidate.backgroundUrl = ''
  }

  /**
   * 选择图片
   */
  picChange(e) {
    this.formValidate.backgroundUrl = e[0].url
  }

  /**
   * 获取商品分类
   */
  getCategoriesAll() {
    GoodsApi.getCategoriesAll().then((res) => {
      if (res.data.items) {
        this.categoryList = res.data.items.map((child) => {
          return {
            value: child.id,
            text: child.fullName,
          }
        })
      }
    })
  }

  /**
   * 商品来源改变
   */
  selectTypeChange(e) {
    if (e == 1) {
      this.ProductsConfig.categoryId = null
    } else {
      this.ProductsConfig.list = []
      this.ProductsConfig.products = []
    }
  }

  /**
   * 选择商品信息
   */
  productsChange(e) {
    if (e) {
      e.forEach((item, index) => {
        if (
          this.ProductsConfig.list.indexOf(item.id) == -1 &&
          index < this.ProductsConfig.maxNumber &&
          this.ProductsConfig.list.length < this.ProductsConfig.maxNumber
        ) {
          this.ProductsConfig.list.push(item.id)
          this.ProductsConfig.products.push({
            code: item.code,
            marketPrice: item.marketPrice,
            name: item.name,
            pictureUrl: item.pictureUrl,
            price: item.price,
            productId: item.id,
          })
        }
      })
    }
  }

  /**
   * 鼠标移入/移出事件
   */
  onMouseFn(index?) {
    this.showGoodsIndex = index
  }

  /**
   * 删除所选商品
   */
  deleteFn(index) {
    this.ProductsConfig.list.splice(index, 1)
    this.ProductsConfig.products.splice(index, 1)
  }

  handleSubmit() {
    ;(this.$refs['formValidate'] as any).validate((valid) => {
      this.loading = true
      // 有检查规则的已经通过
      if (valid) {
        let copyObj = JSON.parse(JSON.stringify(this.formValidate))
        // 检查
        const { photosComponent, componentType } = this.formValidate
        let hasError = false
        let errMes = ''
        // 根据组件类型做对应的检查
        switch (componentType) {
          // 多图组件
          case 0:
            if (photosComponent.displayType === 0) {
              // 检查平铺组件内的图片哪个漏选了
              const { styleType, imgUrl } = this.PicturesConfig
              for (let i = 0, len = imgUrl.length; i < len; i++) {
                if (!imgUrl[i].img) {
                  hasError = true
                  errMes = `平铺展示类型的第 ${i + 1} 张图为空，请选择`
                  break
                }
              }
              copyObj.photosComponent.displayMode = styleType
              copyObj.photosComponent.photoItems = imgUrl.map((o) => {
                return { photoUrl: o.img, linkUrl: o.url }
              })
            } else {
              // 轮播
              const { imgUrl } = this.SwiperConfig
              for (let i = 0, len = imgUrl.length; i < len; i++) {
                if (!imgUrl[i].img) {
                  hasError = true
                  errMes = `轮播展示类型的第 ${i + 1} 张图为空，请选择`
                  break
                }
              }
              copyObj.photosComponent.displayMode = null
              copyObj.photosComponent.photoItems = imgUrl.map((o) => {
                return { photoUrl: o.img, linkUrl: o.url }
              })
            }
            break
          case 1:
            const { products } = this.ProductsConfig
            copyObj.productsComponent.productItems = products.map((o) => {
              return {
                productId: o.productId,
                code: o.code,
                name: o.name,
                marketPrice: o.marketPrice,
                price: o.price,
                pictureUrl: o.pictureUrl,
              }
            })
            break
          default:
            break
        }
        if (hasError) {
          this.$Message.error(errMes)
          this.loading = false
          return
        }
        copyObj.pcHomeTemplateId = this.$route.query.templateId
        console.log(copyObj)
        HomeSetApi.editFloor(this.editId, copyObj).then((res) => {
          this.$Message.success(this.editId ? '修改成功' : '添加成功')
          this.$router.push({
            name: 'pcFloorSet',
            query: {
              id: this.$route.query.templateId,
            },
            replace: true,
          })
        })
        this.loading = false
      } else {
        this.$Message.error('基本信息待完善')
        this.loading = false
      }
    })
  }
}
